import { render, staticRenderFns, recyclableRender, components } from "./my-balance.vue?vue&type=template&id=6f00756a&"
var renderjs
import script from "./my-balance.vue?vue&type=script&lang=js&"
export * from "./my-balance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/user/my-wallet/my-balance.vue"
export default component.exports